import React from "react";
import Skeleton from "react-loading-skeleton";
import styles from "../EventDetail.module.css";

const EventDetailSkeleton = () => {
  return (
    <div className={styles.Detail}>
      <h2 className={styles.Shop}>
        <Skeleton count={1} style={{ width: "50%" }} />
      </h2>

      <div className={styles.DetailBox}>
        <h2 className={styles.Title}>
          <Skeleton count={1} style={{ width: "75%" }} />
        </h2>
        <div>
          <Skeleton height={336} style={{ marginBottom: 30 }} />
        </div>

        <div className={styles.DateRow}>
          <div className={styles.DateItem}>
            <Skeleton count={1} width={100} />
          </div>
          <div className={styles.DateItem}>
            <Skeleton count={1} width={100} />
          </div>
        </div>
        <div className={styles.Content}>
          <Skeleton count={15} />
        </div>
      </div>
    </div>
  );
};

export default EventDetailSkeleton;
